import { EmailThread } from "../../../Components/MailApp/MailAppInterfaces";
import KneeScan from "./EverestMailAssets/KneeScan.webp";

export const EverestMail: EmailThread[] = [
  {
    Emails: [
      {
        Date: "14 June 2025",
        Time: "12:03pm",
        Author: "beverlyhills@citycounsel.co",
        Receiver: "nancy.nelson@amapa.co",
        Subject: "Changes to bin collection schedule",
        Text: `Dear resident,

Your green recycling bins will be collected on Tuesdays and Fridays, starting on 1 July 2025.

If you have any questions, please respond to this email.

Wishing you all the best,

Beverley Hills Council`,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "13 June 2025",
        Time: "1:27pm",
        Author: "laprensadequito@mail.co",
        Receiver: "nancy.nelson@amapa.co",
        Subject: "Manuel Andrade elected Mayor of Quito",
        Text: `On Thursday afternoon, mayoral candidate Manuel Andrade of the Avanza party was elected with 61% of the public vote, marking one of the most decisive victories in Quito’s recent political history. The environmental lawyer turned politician ran on a platform of social equity and sustainability, resonating strongly in a city grappling with rapid urbanization, worsening air pollution, and rising housing costs.

Andrade’s campaign focused on two key pledges: improving Quito’s declining air quality—a growing concern as congestion chokes the Andean valley—and freezing rents in a market where prices have surged nearly 30% since 2020. "We will put people before profit," he told cheering supporters in Plaza Grande, flanked by indigenous leaders and climate activists. His win reflects frustration with the status quo, particularly among young voters and working-class residents displaced by gentrification.

Andrade takes office on June 30, with global attention on whether Quito can become a model for equitable development in Latin America.`,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "12 June 2025",
        Time: "9:32am",
        Author: "globaltimes@mail.co",
        Receiver: "nancy.nelson@amapa.co",
        Subject: "Singapore’s fastest train",
        Text: `With a top speed of 220 mph, it is 20mph faster than the Shikansen, Japan's world renowned bullet train.

The Speedster completed its first successful test run earlier this week, covering the 200-mile stretch between Singapore and Kuala Lumpur in just under 55 minutes—a journey that typically takes over four hours by car.

Transport Minister Lee Wei Ming hailed the project as a "game-changer for regional connectivity," emphasizing its potential to revolutionize travel across Southeast Asia.

Singapore plans to extend the Speedster network to Thailand and Indonesia by 2030.`,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "11 June 2025",
        Time: "5:49pm",
        Author: "william.fulbright@amapa.co",
        Receiver: "nancy.nelson@amapa.co",
        Subject: "New marketing campaign",
        Text: `Hi Nancy,

I hope your Everest expedition is going as spectacularly as it looks from the photos!

This is just a quick note about this winter’s marketing campaign.

Since dropping Ethan after the doping ban, we still haven’t found the new face of Amapa.

I was speaking to Margot in marketing and she suggested we put your Everest expedition front and center. I think it’s a fantastic idea as it follows our three key principles of marketing: adventure in nature, personal stories, and specialist names like Ranjana.

All the best,

Bill`,
      },
    ],
  },
  {
    Emails: [
      {
        Date: "11 June 2025",
        Time: "8:14pm",
        Author: "darwin.nelson@mail.co",
        Receiver: "nancy.nelson@amapa.co",
        Subject: "Broken Knee",
        Text: `Mom,

Everything is okay here. Dad’s with me in the hospital.

They did a scan on my knee. It’s broken. They said full recovery should be in another 4 to 5 months.

Good luck and be safe`,
        imageContent: KneeScan,
      },
    ],
  },
];
